<!--
個人志 personalPeripheral.vue
-->

<template>
  <transition title="el-fade-in-linear">
    <div>
      <el-row style="margin:auto;">
        <h2 style="text-align:center">个人周边代理</h2>
        <br>
        <el-collapse v-model="InformationCollapse">
          <el-collapse-item title="个人周边说明" name="个人周边说明">
            <p v-html="个人周边说明" style="font-size:130%"></p>
          </el-collapse-item>
        </el-collapse>
        <center>
          <el-button v-on:click="addEvent()" style="margin-right:5px">提交</el-button>
        </center>
      </el-row>
    </div>
  </transition>
</template>
<style>
</style>
<script lang="ts">
export default {
  name: "personalPeripheral",
  methods: {
    addEvent: function() {
      this.$root.add(this.personalPeripheralFormData);
      this.clear();
    },
    clear: function() {
      this.personalPeripheralFormData = {
        title: "个人周边代理",
        留言内容: "申请个人周边"
      };
    }
  },
  data() {
    return {
      personalPeripheralFormData: {
        title: "个人周边代理",
        留言内容: "申请个人周边"
      },
      个人周边说明: `<p>“个⼈周边代理”服务，是漫寻⾕⾯向有推出个⼈原创周边（⽴牌、挂件、帆布袋等⾮收藏册形式的各类制品）意愿的作者，推出的⼀项个性化定制服务。</p>
<p>在这项服务中，委托⼈可以委托我们负责周边制作过程中的，从前期定位、主题、成品类型，到之后样品制作、定量、量产，再到后续贩售等任环节或所有环节。⽽相应的，委托⼈需要提供作品内容主体定稿，以及最终决定的制品形式。</p>
<p>通过漫寻⾕的全⽅位⽀持，作者可以在创作过程中享受到充分的便利。当然，由于周边制品的内容主题、制品类型的多样，漫寻⾕也将采⽤更有个性化的结算模式。</p>
<p>想了解关于“个⼈周边代理”服务的更多细节，或是想直接体验我们“个⼈周边代理”服务的作者，可以点击底部提交按钮，我们将有专员联系您。</p>`,
      InformationCollapse: ["个人周边说明"]
    };
  }
};
</script>
>